import React, { Component } from 'react';

const clauses = [
  {
    title: 'PEMBAYARAN DAN BIAYA',
    items: [
      'Biaya layanan wajib dibayarkan paling lambat 10 (sepuluh) hari kalender sejak tanggal penagihan (invoice) hanya melalui Virtual Account (VA) resmi yang ditentukan oleh NEXA.',
      'Keterlambatan pembayaran mengakibatkan pemutusan sementara (isolir) layanan tanpa pemberitahuan terlebih dahulu dan dapat dikenakan denda keterlambatan serta biaya administrasi penyambungan kembali. Harga belum termasuk PPN sesuai ketentuan peraturan perundang-undangan yang berlaku.',
      'Segala pajak dan biaya administrasi bank yang timbul menjadi tanggung jawab Pelanggan.',
      'Seluruh biaya yang telah dibayarkan kepada NEXA tidak dapat ditarik kembali (non-refundable) dengan alasan apapun.',
    ],
  },
  {
    title: 'INSTALASI DAN JANGKA WAKTU',
    items: [
      'Proses instalasi layanan dilakukan dalam jangka waktu maksimum 14 (empat belas) hari kerja setelah seluruh persyaratan administrasi dan pembayaran awal (jika ada) dipenuhi oleh Pelanggan.',
      'Jangka waktu berlangganan minimal adalah 12 (dua belas) bulan sejak tanggal aktivasi layanan (Masa Kontrak).',
      'Perjanjian ini otomatis diperpanjang untuk jangka waktu yang sama kecuali terdapat permintaan pemutusan tertulis dari salah satu Pihak minimal 30 (tiga puluh) hari sebelum masa berlaku berakhir.',
    ],
  },
  {
    title: 'LAYANAN DAN PEMELIHARAAN',
    items: [
      'NEXA berhak melakukan pemeliharaan jaringan secara berkala (scheduled maintenance) dengan pemberitahuan terlebih dahulu melalui media komunikasi resmi. Downtime akibat pemeliharaan tersebut serta kejadian di luar kendali NEXA (Force Majeure) tidak dianggap sebagai pelanggaran layanan.',
      'NEXA memberikan layanan dengan basis Best Effort (upaya terbaik) tanpa jaminan ketersediaan layanan pada waktu tertentu secara mutlak.',
      'Tanggung jawab NEXA atas gangguan layanan terbatas pada pemberian restitusi biaya berlangganan yang dihitung secara prorata, yang pelaksanaannya merupakan diskresi sepenuhnya dari NEXA berdasarkan validasi sistem NEXA.',
    ],
  },
  {
    title: 'KEWAJIBAN, LARANGAN DAN PENALTI',
    items: [
      'Pelanggan dilarang keras menjual kembali (resell), membagi, atau mendistribusikan ulang layanan kepada pihak manapun tanpa izin tertulis dari NEXA.',
      'Seluruh perangkat yang dipasang di lokasi Pelanggan adalah milik NEXA. Pelanggan wajib menjaga perangkat tersebut dan bertanggung jawab atas penggantian biaya penuh apabila terjadi kerusakan atau kehilangan akibat kelalaian Pelanggan.',
      'Apabila Pelanggan memutuskan mengakhiri layanan sebelum berakhirnya Masa Kontrak, maka Pelanggan diwajibkan membayar denda pemutusan dini (Early Termination Fee) sebesar 50% dari biaya bulanan dikali dengan sisa masa kontrak yang belum berjalan.',
    ],
  },
  {
    title: 'BATASAN TANGGUNG JAWAB',
    items: [
      'NEXA tidak bertanggung jawab atas segala bentuk kerugian tidak langsung, kehilangan data, kehilangan keuntungan bisnis, atau konsekuensi finansial lainnya yang dialami Pelanggan akibat gangguan layanan.',
      'NEXA dibebaskan dari tanggung jawab jika terjadi Force Majeure (bencana alam, sabotase, kebijakan pemerintah, atau gangguan pada provider hulu/kabel laut).',
    ],
  },
  {
    title: 'KERAHASIAAN, DATA PRIBADI DAN SENGKETA',
    items: [
      'Pelanggan memberikan persetujuan kepada NEXA untuk mengolah dan menggunakan data pribadi Pelanggan guna kepentingan operasional layanan dan pemenuhan kewajiban hukum sesuai UU Pelindungan Data Pribadi.',
      'Pelanggan menjamin kebenaran seluruh data yang diberikan dalam Formulir Berlangganan dan wajib menginformasikan perubahan data tersebut kepada NEXA secara tertulis.',
      'Syarat dan Ketentuan ini tunduk pada hukum Republik Indonesia. Segala perubahan S&K akan diinformasikan melalui website atau media komunikasi resmi NEXA. Penggunaan layanan yang berlanjut setelah adanya perubahan tersebut dianggap sebagai persetujuan penuh Pelanggan terhadap perubahan S&K.',
      'Setiap perselisihan akan diselesaikan secara musyawarah dalam waktu 30 (tiga puluh) hari kalender. Apabila tidak tercapai mufakat, PARA PIHAK sepakat untuk memilih domisili hukum yang tetap dan tidak berubah di Kantor Kepaniteraan Pengadilan Negeri Semarang.',
    ],
  },
];

export default class Content extends Component {
  render() {
    return (
      <section className="contacts-section2 syarat-doc">
        <style>{`
          .syarat-doc ol.syarat-list li { margin-bottom: 0.5rem; }
          .syarat-doc ol.syarat-list li::marker { color: inherit; font-size: inherit; font-weight: inherit; }
        `}</style>

        <div className="contacts-container01">
          <span className="contacts-text">Terms</span>
          <h2 className="contacts-text01 fw-bold">
            Syarat dan Ketentuan Berlangganan
          </h2>
          <span className="contacts-text02 text-left">
            Syarat dan Ketentuan ini merupakan satu kesatuan yang tidak
            terpisahkan dari Formulir Berlangganan (FB) yang ditandatangani PARA
            PIHAK dan mengikat secara hukum terhitung sejak tanggal aktivasi
            layanan sebagaimana tercantum dalam Berita Acara Aktivasi (BAA).
          </span>
        </div>

        {clauses.map((clause, index) => (
          <div className="contacts-container01" key={index}>
            <h2 className="contacts-text05 fw-bold">
              {clause.title}
            </h2>
            <div className="contacts-text02 text-left w-100">
              <ol className="syarat-list" style={{ listStyleType: 'lower-alpha', paddingLeft: '1.5em', textAlign: 'left' }}>
                {clause.items.map((item, itemIndex) => (
                  <li key={itemIndex}>{item}</li>
                ))}
              </ol>
            </div>
          </div>
        ))}
      </section>
    );
  }
}
